import React from 'react';
import NotFoundView from './NotFound.Component.jsx';
import Helmet from 'react-helmet';

export default class NotFound extends React.Component {
  render() {
    return (
      <div>
        <Helmet title="Page Not Found"/>
        <NotFoundView />
      </div>
    );
  }
}

NotFound.displayName = 'NotFound';



// WEBPACK FOOTER //
// ./shared/common/NotFound.Page.jsx